import { useEffect, useState } from "react";
import client from "../lib/api";
import VideoCard from "../components/VideoCard";

const TYPES = [
  { key: "all", label: "All" },
  { key: "long", label: "Videos" },
  { key: "short", label: "Shorts" },
  { key: "story", label: "Stories" },
];

export default function Library() {
  const [type, setType] = useState("all");
  const [cat, setCat] = useState("all");
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);

  useEffect(() => { client.get("/videos/categories").then((r) => setCats(r.data)); }, []);
  useEffect(() => {
    const params = new URLSearchParams();
    if (type !== "all") params.set("type", type);
    if (cat !== "all") params.set("category", cat);
    client.get(`/videos?${params.toString()}`).then((r) => setItems(r.data));
  }, [type, cat]);

  return (
    <div className="px-4 sm:px-8 lg:px-12 py-10" data-testid="library-page">
      <span className="text-[10px] uppercase tracking-[0.3em] text-[#FFB800]">Browse</span>
      <h1 className="text-3xl sm:text-4xl font-bold text-white">The Full Library</h1>
      <div className="mt-6 flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2 flex-wrap">
          {TYPES.map((t) => (
            <button
              key={t.key}
              onClick={() => setType(t.key)}
              data-testid={`filter-type-${t.key}`}
              className={`text-xs uppercase tracking-widest px-4 h-9 rounded-full border transition-colors ${
                type === t.key
                  ? "bg-[#FF6B00] text-black border-[#FF6B00] font-bold"
                  : "bg-transparent text-zinc-400 border-white/10 hover:border-white/30 hover:text-white"
              }`}
            >{t.label}</button>
          ))}
        </div>
        <div className="h-6 w-px bg-white/10 mx-2 hidden sm:block" />
        <div className="flex items-center gap-2 flex-wrap">
          <button
            onClick={() => setCat("all")}
            data-testid="filter-cat-all"
            className={`text-xs uppercase tracking-widest px-3 h-8 rounded-full border ${
              cat === "all" ? "border-[#FFB800] text-[#FFB800]" : "border-white/10 text-zinc-500 hover:text-white"
            }`}
          >All categories</button>
          {cats.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`filter-cat-${c}`}
              className={`text-xs uppercase tracking-widest px-3 h-8 rounded-full border ${
                cat === c ? "border-[#FFB800] text-[#FFB800]" : "border-white/10 text-zinc-500 hover:text-white"
              }`}
            >{c}</button>
          ))}
        </div>
      </div>

      <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-testid="library-grid">
        {items.map((v) => <VideoCard key={v.id} video={v} size="lg" />)}
      </div>
      {items.length === 0 && (
        <p className="mt-12 text-center text-zinc-500">No transmissions in this slice of the Nexus.</p>
      )}
    </div>
  );
}
